import Panel from "components/panels/panel";
import React from "react";
import { useCustomQuery } from "utilities/hookutils";
import { routes } from "utilities/routing/generatedRoutes";
import { AppointmentPhase, Status } from "components";
import { OrderableTable } from "components/Tables";
import { formatMainAreaItemWithCount } from "utilities/translationUtils";
import { ButtonPrimary } from "components/Atoms/Button";
import TwoColumnLayout from "layout/TwoColumnLayout";
import RightSideNavigation from "components/RightSideNavigation/RightSideNavigation";
import { useLoaderData } from "react-router";

const ListStatusApp = () => {
  const viewModel = useLoaderData<server.viewmodel.StatusListFrontModel>();
  const [statuses, setStatuses] = React.useState<server.dto.Status[]>([]);

  const statusesApi = useCustomQuery({
    queryFn: async () => {
      return window.CoreApi.Status.List(viewModel.mainArea);
    },
    queryKey: ["listStatus", viewModel.mainArea],
    onSuccess: (response) => {
      if (response.data.hasErrors) {
        return;
      }
      setStatuses(response.data.data);
    },
    cacheTime: 0
  });

  const onOrderChanged = async (newStatuses: server.dto.Status[]) => {
    setStatuses(newStatuses);
    await window.CoreApi.Status.StoreSorted({ mainArea: viewModel.mainArea, statusIds: newStatuses.map(status => status.statusId) });
  };

  return <TwoColumnLayout>
    <TwoColumnLayout.LeftColumn>
      <Panel
        button={<ButtonPrimary label={RESX.GeneralLabels.resxNew} href={routes.status_New(viewModel.mainArea).absolute} />}
        panelClassName="s1_listview-panel"
        title={`${RESX.Status.Statuses}: ${statuses.length}`}
        headerSize="h1"
      >
        <OrderableTable
          onOrderChanged={onOrderChanged}
          items={statuses}
          isLoading={statusesApi.isLoading}
          getKey={(item) => item.statusId.toString()}
          columns={[{
            key: "title",
            header: RESX.GeneralLabels.Title,
            render: (item) => <Status
              status={item}
              linkTo={routes.status_Detail(item.statusId).absolute}
            />
          }, {
            key: "treatAs",
            header: RESX.Status.TreatAs,
            render: (item) => <AppointmentPhase value={item.appointmentPhase} displayLabel />,
            hidden: viewModel.mainArea !== "show"
          }, {
            key: "withStatus",
            header: RESX.Status.WithStatus,
            render: (item) => formatMainAreaItemWithCount(item.itemsWithStatus, viewModel.mainArea),
            width: 150,
            style: { textAlign: "right" }
          }]}
        />
      </Panel>
    </TwoColumnLayout.LeftColumn>
    <RightSideNavigation
      title={site.navigation.rightSideNavigation.title}
      menuItems={site.navigation.rightSideNavigation.items}
      currentPage={site.currentPage}
    />
  </TwoColumnLayout>;
};

export default ListStatusApp;